import { HighlightedText } from '~/components/HighlightedText'
import { NetworkLogoView } from '~/components/component-library'
import {
  LOGO_SIZE,
  networkDisplayStyles,
} from '~/components/component-library/NetworkDisplay/styles'
import { NetworkDisplayViewProps } from '~/components/component-library/NetworkDisplay/types'
import { cn } from '~/utils/tailwind-utils'

// Presentational half of NetworkDisplay: the container resolves the name and
// relay metadata so this renders without fetching, like TokenDisplayView.
export const NetworkDisplayView = ({
  chainId,
  layout,
  size,
  label,
  relayNetworkInfo,
  highlightText,
}: NetworkDisplayViewProps) => {
  const name = <HighlightedText text={label} highlight={highlightText} />

  if (layout === 'inline-text') {
    return <span className={cn(networkDisplayStyles({ layout }))}>{name}</span>
  }

  return (
    <span className={cn(networkDisplayStyles({ layout, size }))}>
      <NetworkLogoView
        variant="standalone"
        chainId={chainId}
        size={LOGO_SIZE[size]}
        relayNetworkInfo={relayNetworkInfo}
      />
      <span className="min-w-0 truncate">{name}</span>
    </span>
  )
}
